import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from "../shared/shared";
import { VertragService } from "./vertrag.service";
import { AuthModule, AuthGuard } from '../_authentication/auth';
import { AgGridModule } from 'ag-grid-angular';
import { InputFileComponent } from '../shared/directives/input-file/input-file.component';
import { ByteFormatPipe } from '../shared/directives/input-file/pipe/byte-format.pipe';
import { MoneyRendererComponent } from '../shared/grid/renderer/money-renderer.component';
import { EnumRendererComponent } from '../shared/grid/renderer/enum-renderer.component';
import { CellButtonComponent } from '../shared/grid/buttons/cell-button.component';
import { HeaderButtonComponent } from '../shared/grid/buttons/header-button.component';
import { CurrencyFormatterDirective } from '../shared/directives/currency.directive';
import { CustomCurrencyPipe } from '../shared/pipes/Currency.pipe';
import { VertragComponent } from './vertrag.component';
import { VertragListComponent } from './vertrag-list/vertrag-list.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { TerminListComponent } from './vertrag-list/termin-list/termin-list.component';
import { ZahlungListComponent } from './vertrag-list/zahlung-list/zahlung-list.component';
import { AgGridServer } from './ag-grid-server.service';
import { DataExportService } from '../shared/data-export.service';

const vereinRoutes: Routes = [
    {
        path: 'vertrag', component: VertragComponent, canActivate: [AuthGuard],
        children: [
            {
                path: '', component: VertragListComponent, canActivate: [AuthGuard]
            },
            {
                path: 'impressum', component: ImpressumComponent, canActivate: [AuthGuard]
            }
        ]
    }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(vereinRoutes),
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        AuthModule.forRoot(),
        AgGridModule.withComponents([
            HeaderButtonComponent,
            CellButtonComponent,
            MoneyRendererComponent,
            EnumRendererComponent,
        ]),
    ],
    exports: [VertragComponent],
    declarations: [
        VertragComponent,
        VertragListComponent,
        ImpressumComponent,
        TerminListComponent,
        ZahlungListComponent,

        HeaderButtonComponent,
        CellButtonComponent,
        MoneyRendererComponent,
        EnumRendererComponent,

        InputFileComponent,
        ByteFormatPipe,
        CustomCurrencyPipe,
        CurrencyFormatterDirective,
    ],
    bootstrap: [VertragComponent],
    entryComponents: [TerminListComponent, ZahlungListComponent]
})
export class VertragModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: VertragModule,
            providers: [VertragService, CurrencyPipe, CustomCurrencyPipe, AgGridServer, DataExportService]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag.module.ts